import 'tippy.js/dist/tippy.css';
import tippy, { followCursor } from 'tippy.js';

import './tooltip.scss';

export default {
  beforeMount(el, binding = {}) {
    if (!binding?.value) return;

    const arrow = !!binding.modifiers?.arrow;
    const hideOnClick = !!binding.modifiers?.onclick;
    const follow = !!binding.modifiers?.follow;
    const interactive = !!binding.modifiers?.interactive;
    const onClickOpts = {
      trigger: 'click',
      hideOnClick: true,
      interactive,
    };
    const notOnclickOpts = {
      followCursor: follow ? 'horizontal' : false,
      plugins: follow ? [followCursor] : [],
      interactive,
    };

    tippy(el, {
      theme: 'funday',
      content: binding.value,
      arrow,
      placement: 'bottom',
      allowHTML: true,
      ...(hideOnClick ? onClickOpts : notOnclickOpts),
    });
  },
};
